export const WIDGETS = [
    { value: 'password', label: 'Password' },
    { value: 'textarea', label: 'Long Text' },
    { value: 'hidden', label: 'Hidden' },
    { value: 'amount', label: 'Amount' },
    { value: 'checkbox', label: 'Checkbox' },
    { value: 'checklist', label: 'Checklist' },
    { value: 'ckeditor', label: 'CKEditor' },
    { value: 'geolocation', label: 'Geo Location' },
    { value: 'file', label: 'File' },
    { value: 'ifsc', label: 'IFSC Code' },
    { value: 'list', label: 'List' },
    { value: 'monthpicker', label: 'Month Picker' },
    { value: 'page_item', label: 'Page Item' },
    { value: 'pincode', label: 'Pin Code' },
    {
        value: 'rich_checkbox',
        label: 'Rich Checkbox',
    },
    {
        value: 'rich_radio',
        label: 'Rich Radio Buttons',
    },
    {
        value: 'select2',
        label: 'Select with Search',
    },
    {
        value: 'async_select',
        label: 'Select with Async Search',
    },
    { value: 'selfie', label: 'Selfie' },
];

export const FIELD_SETTINGS = [
    {
        value: 'ui:widget',
        label: 'Widget',
    },
    {
        value: 'ui:label',
        label: 'Hide Label?',
    },
    {
        value: 'ui:disabled',
        label: 'Disabled?',
    },
    {
        value: 'ui:placeholder',
        label: 'Placeholder',
    },
    {
        value: 'ui:enumNames',
        label: 'Option Names',
    },
    {
        value: 'ui:autofocus',
        label: 'Autofocus?',
    },
];

export const INPUT_TYPES = [
    { value: 'object', label: 'Object' },
    { value: 'string', label: 'String' },
    { value: 'number', label: 'Number' },
    { value: 'boolean', label: 'Boolean' },
];

export const TYPE_ICONS = {
    string: 'bi bi-type',
    number: 'bi bi-123',
    integer: 'bi bi-123',
    object: 'bi bi-list-nested',
    boolean: 'bi bi-toggle-on',
    array: 'bi bi-view-stacked',
};

export const API_METHODS = [
    { value: 'get', label: 'GET' },
    { value: 'post', label: 'POST' },
    { value: 'put', label: 'PUT' },
    { value: 'delete', label: 'DELETE' },
    { value: 'patch', label: 'PATCH' },
    { value: 'options', label: 'OPTIONS' },
    { value: 'head', label: 'HEAD' },
];

export const RESPONSE_TYPES = [
    { value: 'json', label: 'JSON' },
    { value: 'file', label: 'File' },
];

export const NODE_TYPES = {
    default: {
        width: '180px',
    },
    web_form: {
        width: '180px',
    },
    task: {
        width: '180px',
        height: '80px',
    },
    edge_operation: {
        width: '180px',
        height: '80px',
    },
    expression: {
        width: '180px',
        height: '80px',
    },
    api_request: {
        width: '400px',
    },
    flow_connector: {
        width: '180px',
    },
};
